import axios from 'axios'

export class UserService {
  async getRelationTuples() {
    return axios.get('/relation-tuples')
  }
}
